export const getPriceColor = (price) => {
  switch(price) {
    case 'Free': return '#10b981';
    case 'Pro': return '#8b5cf6';
    case 'Enterprise': return '#f59e0b';
    default: return '#8b5cf6';
  }
};

export const getAlertColor = (type) => {
  switch(type) {
    case 'warning': return '#f59e0b';
    case 'error': return '#ef4444';
    case 'success': return '#10b981';
    case 'info': return '#06b6d4';
    default: return '#8b5cf6';
  }
};

export const categories = ['All', 'Service', 'Analytics', 'Security', 'Operations', 'Finance', 'HR', 'Legal', 'Marketing'];